export default "__VITE_ASSET__CUAhYze$__"